
      var _path, _g, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _g4, _path7, _g5, _path8, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgJobCareersBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1440,
  height: 446,
  viewBox: "0 0 1440 446",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-240)",
  fill: "url(#JobCareersBackground_f01d2e291a6bd5b3__a)",
  d: "M0 0h1920v430H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.25 401.642A27.75 27.75 0 0 1 53 373.892h74a27.749 27.749 0 0 1 27.75 27.75",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90 333.766v67.528M90 298v14",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.364 168.178a9.251 9.251 0 0 0-9.158 7.943l-15.863 111a9.25 9.25 0 0 0 9.157 10.557h111a9.258 9.258 0 0 0 6.988-3.189 9.26 9.26 0 0 0 2.17-7.368l-15.864-111a9.252 9.252 0 0 0-9.158-7.943H50.364z",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M180.486 260.225a1.846 1.846 0 1 1 .567-3.65 1.846 1.846 0 1 1-.567 3.65z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m185.855 269.782 4.95 8.245",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m173.415 261.62-.567 3.65a14.777 14.777 0 0 0 12.334 16.869L201 284.596l-11.766-20.519.472-3.042a8.003 8.003 0 0 0-15.254-4.412l-4.309 1.996 3.272 3.001z",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M164.513 397.369h9.862m-9.862-4.93H194.1m-280.883 9.963h209.229",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 10.636,
  y: 311.626,
  width: 159.412,
  height: 22.141,
  rx: 11.07,
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.74 285.058v26.053c0 4.342-3.607 12.693-12.692 12.693M-3.756 285.058v26.053c0 4.342 3.608 12.693 12.693 12.693",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  d: "M174.527 283.308h16.427m-186.496 0H-11.97"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__d)",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m249.306 93.702-15.488 35.683a2.996 2.996 0 0 0 1.554 3.936l60.385 26.209a2.994 2.994 0 0 0 3.936-1.553l15.488-35.682-23.407-36.255-42.468 7.662zm18.611 30.913-34.105 7.108m64.179 27.857-18.1-29.768"
}), /*#__PURE__*/React.createElement("path", {
  d: "m315.181 122.294-35.286 7.517-11.978-5.199-18.611-30.91"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m303.797 166 3.192 7.336m-9.489-4.596 9.576 22.007",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1085.62 187.198h8.91",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1067.8 182.743h26.73",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3.5,
  strokeLinecap: "round"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__e)",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1123.83 148.507a13.581 13.581 0 0 0-4.87-4.702 13.162 13.162 0 0 0-6.47-1.706 14.17 14.17 0 0 0-1.77 5.861c-.16 2.066.14 4.141.86 6.074a13.502 13.502 0 0 0-2.2 7.289v2.136c0 3.399 1.31 6.658 3.64 9.062 2.33 2.403 5.49 3.754 8.79 3.754h12.42c3.3 0 6.46-1.351 8.79-3.754 2.33-2.404 3.64-5.663 3.64-9.062v-2.136a13.418 13.418 0 0 0-2.2-7.289c.72-1.933 1.02-4.008.86-6.074a14.307 14.307 0 0 0-1.76-5.861c-2.27-.001-4.49.586-6.47 1.706a13.53 13.53 0 0 0-4.88 4.702h-8.38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1119.74 195.498v-10.68a8.69 8.69 0 0 1 2.42-6.041c1.56-1.602 3.66-2.503 5.86-2.503s4.31.901 5.86 2.503a8.7 8.7 0 0 1 2.43 6.041v10.68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1119.74 189.089h-8.29c-2.2 0-4.3-.9-5.86-2.503a8.69 8.69 0 0 1-2.42-6.041c0-2.266-.88-4.439-2.43-6.042-1.56-1.602-3.66-2.502-5.86-2.502"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1259.23 208.764 1110.76 356m0-147.236L1259.23 356",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinejoin: "round",
  d: "M1060 196.438h248.801v12.303H1060z"
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__f)",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1160.99 147.097h113.81",
  stroke: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1170.47 170.807h94.84c5.24 0 9.49-4.246 9.49-9.484V94.936c0-5.238-4.25-9.484-9.49-9.484h-94.84c-5.23 0-9.48 4.246-9.48 9.484v66.387c0 5.238 4.25 9.484 9.48 9.484zm66.39 18.966h-37.93m18.96-18.966v18.967",
  stroke: "#000"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M1281 215h40",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round"
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__g)",
  strokeWidth: 2.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1307.07 62.181c-.77-.38-2.65-1.675-1.74-4.94.93-3.36 2.39-7.399 5.27-5.748 2.88 1.651 4.93 8.672 3.25 11.607 1.68-2.935 8.77-4.717 11.65-3.066 2.89 1.652.14 4.95-2.29 7.458-2.36 2.434-4.42 1.465-5.14.996",
  stroke: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1317.63 56.499-6.54 11.418m5.58-1.204c.6.435 1.06 1.034 1.32 1.724.27.69.33 1.444.18 2.167a3.915 3.915 0 0 1-1.04 1.913 3.813 3.813 0 0 1-4.07.879c-.69-.263-1.3-.72-1.73-1.316a3.797 3.797 0 0 1-.74-2.046c-.04-.739.13-1.474.5-2.117a3.817 3.817 0 0 1-1.58 1.486 3.78 3.78 0 0 1-2.12.393 3.785 3.785 0 0 1-2-.826 3.791 3.791 0 0 1-1.3-3.944c.19-.712.57-1.355 1.12-1.851a3.803 3.803 0 0 1 1.95-.947c.72-.12 1.47-.03 2.14.263",
  stroke: "#000"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M1170 356h575",
  stroke: "#000",
  strokeWidth: 3.5,
  strokeLinecap: "round"
})), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#JobCareersBackground_f01d2e291a6bd5b3__h)",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1354.16 320.953c5.27-8.79-1.76-17.578-16.7-16.699-.89 14.936 7.9 21.966 16.7 16.699zm-12.14 10.985h41.62m-4.62 0-4.23 19.002a2.313 2.313 0 0 1-2.26 1.81h-19.41c-.53 0-1.04-.179-1.45-.508a2.343 2.343 0 0 1-.81-1.302l-4.22-19.002m20.89-11.643-11.64 11.643m-1.74-10.991 6.37 6.365",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1367.53 320.294c-7.25-12.086 2.42-24.169 22.96-22.96 1.21 20.543-10.87 30.21-22.96 22.96z",
  stroke: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(-58 150)",
  d: "M0 0h296v296H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "scale(-1 1) rotate(-8.828 1528.156 1468.82)",
  d: "M0 0h39.404v39.404H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(23.463 -8.523 636.254)",
  d: "M0 0h95.75v95.75H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__e"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(1092.81 133.555)",
  d: "M0 0h66.281v68.352H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__f"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(1142.02 57)",
  d: "M0 0h151.741v151.741H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__g"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "scale(-1 1) rotate(-29.817 -557.075 2531.3)",
  d: "M0 0h27.169v27.169H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__h"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(1322 288)",
  d: "M0 0h74v74H0z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "JobCareersBackground_f01d2e291a6bd5b3__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 1354 -6045.77 0 959.999 130.5)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.199,
  stopColor: "#C5A0EF"
})))));

      const __svgRaw = "<svg width=\"1440\" height=\"446\" viewBox=\"0 0 1440 446\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path transform=\"translate(-240)\" fill=\"url(#3lbly1s43a)\" d=\"M0 0h1920v430H0z\"/>\r\n    <g clip-path=\"url(#x2mtfx2e5b)\">\r\n        <path d=\"M25.25 401.642A27.75 27.75 0 0 1 53 373.892h74a27.749 27.749 0 0 1 27.75 27.75\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n        <path d=\"M90 333.766v67.528M90 298v14\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n        <path d=\"M50.364 168.178a9.251 9.251 0 0 0-9.158 7.943l-15.863 111a9.25 9.25 0 0 0 9.157 10.557h111a9.258 9.258 0 0 0 6.988-3.189 9.26 9.26 0 0 0 2.17-7.368l-15.864-111a9.252 9.252 0 0 0-9.158-7.943H50.364z\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n        <g clip-path=\"url(#ytl1sylm8c)\">\r\n            <path d=\"M180.486 260.225a1.846 1.846 0 1 1 .567-3.65 1.846 1.846 0 1 1-.567 3.65z\" fill=\"#000\"/>\r\n            <path d=\"m185.855 269.782 4.95 8.245\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n            <path d=\"m173.415 261.62-.567 3.65a14.777 14.777 0 0 0 12.334 16.869L201 284.596l-11.766-20.519.472-3.042a8.003 8.003 0 0 0-15.254-4.412l-4.309 1.996 3.272 3.001z\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n        </g>\r\n        <path d=\"M164.513 397.369h9.862M164.513 392.439H194.1M-86.783 402.402h209.229\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>\r\n        <rect x=\"10.636\" y=\"311.626\" width=\"159.412\" height=\"22.141\" rx=\"11.07\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linejoin=\"round\"/>\r\n        <path d=\"M182.74 285.058v26.053c0 4.342-3.607 12.693-12.692 12.693M-3.756 285.058v26.053c0 4.342 3.608 12.693 12.693 12.693\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n        <path stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" d=\"M174.527 283.308h16.427M4.458 283.308H-11.97\"/>\r\n    </g>\r\n    <g clip-path=\"url(#e749lz473d)\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"m249.306 93.702-15.488 35.683a2.996 2.996 0 0 0 1.554 3.936l60.385 26.209a2.994 2.994 0 0 0 3.936-1.553l15.488-35.682-23.407-36.255-42.468 7.662zM267.917 124.615l-34.105 7.108M297.991 159.58l-18.1-29.768\"/>\r\n        <path d=\"m315.181 122.294-35.286 7.517-11.978-5.199-18.611-30.91\"/>\r\n    </g>\r\n    <path d=\"m303.797 166 3.192 7.336M297.5 168.74l9.576 22.007\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>\r\n    <path d=\"M1085.62 187.198h8.91\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>\r\n    <path d=\"M1067.8 182.743h26.73\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>\r\n    <g clip-path=\"url(#nzycpm7n7e)\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M1123.83 148.507a13.581 13.581 0 0 0-4.87-4.702 13.162 13.162 0 0 0-6.47-1.706 14.17 14.17 0 0 0-1.77 5.861c-.16 2.066.14 4.141.86 6.074a13.502 13.502 0 0 0-2.2 7.289v2.136c0 3.399 1.31 6.658 3.64 9.062 2.33 2.403 5.49 3.754 8.79 3.754h12.42c3.3 0 6.46-1.351 8.79-3.754 2.33-2.404 3.64-5.663 3.64-9.062v-2.136a13.418 13.418 0 0 0-2.2-7.289c.72-1.933 1.02-4.008.86-6.074a14.307 14.307 0 0 0-1.76-5.861c-2.27-.001-4.49.586-6.47 1.706a13.53 13.53 0 0 0-4.88 4.702h-8.38z\"/>\r\n        <path d=\"M1119.74 195.498v-10.68a8.69 8.69 0 0 1 2.42-6.041c1.56-1.602 3.66-2.503 5.86-2.503s4.31.901 5.86 2.503a8.7 8.7 0 0 1 2.43 6.041v10.68\"/>\r\n        <path d=\"M1119.74 189.089h-8.29c-2.2 0-4.3-.9-5.86-2.503a8.69 8.69 0 0 1-2.42-6.041c0-2.266-.88-4.439-2.43-6.042-1.56-1.602-3.66-2.502-5.86-2.502\"/>\r\n    </g>\r\n    <path d=\"M1259.23 208.764 1110.76 356M1110.76 208.764 1259.23 356\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path stroke=\"#000\" stroke-width=\"3.5\" stroke-linejoin=\"round\" d=\"M1060 196.438h248.801v12.303H1060z\"/>\r\n    <g clip-path=\"url(#wrik5te5gf)\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M1160.99 147.097h113.81\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n        <path d=\"M1170.47 170.807h94.84c5.24 0 9.49-4.246 9.49-9.484V94.936c0-5.238-4.25-9.484-9.49-9.484h-94.84c-5.23 0-9.48 4.246-9.48 9.484v66.387c0 5.238 4.25 9.484 9.48 9.484zM1236.86 189.773h-37.93M1217.89 170.807v18.967\" stroke=\"#000\"/>\r\n    </g>\r\n    <path d=\"M1281 215h40\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>\r\n    <g clip-path=\"url(#e75rlvfdzg)\" stroke-width=\"2.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M1307.07 62.181c-.77-.38-2.65-1.675-1.74-4.94.93-3.36 2.39-7.399 5.27-5.748 2.88 1.651 4.93 8.672 3.25 11.607 1.68-2.935 8.77-4.717 11.65-3.066 2.89 1.652.14 4.95-2.29 7.458-2.36 2.434-4.42 1.465-5.14.996\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n        <path d=\"m1317.63 56.499-6.54 11.418M1316.67 66.713c.6.435 1.06 1.034 1.32 1.724.27.69.33 1.444.18 2.167a3.915 3.915 0 0 1-1.04 1.913 3.813 3.813 0 0 1-4.07.879c-.69-.263-1.3-.72-1.73-1.316a3.797 3.797 0 0 1-.74-2.046c-.04-.739.13-1.474.5-2.117a3.817 3.817 0 0 1-1.58 1.486c-.65.334-1.39.47-2.12.393a3.785 3.785 0 0 1-2-.826 3.791 3.791 0 0 1-1.3-3.944c.19-.712.57-1.355 1.12-1.851a3.803 3.803 0 0 1 1.95-.947c.72-.12 1.47-.03 2.14.263\" stroke=\"#000\"/>\r\n    </g>\r\n    <path d=\"M1170 356h575\" stroke=\"#000\" stroke-width=\"3.5\" stroke-linecap=\"round\"/>\r\n    <g clip-path=\"url(#fou4tdqpsh)\" stroke-width=\"3.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M1354.16 320.953c5.27-8.79-1.76-17.578-16.7-16.699-.89 14.936 7.9 21.966 16.7 16.699zM1342.02 331.938h41.62M1379.02 331.938l-4.23 19.002a2.313 2.313 0 0 1-2.26 1.81h-19.41c-.53 0-1.04-.179-1.45-.508a2.343 2.343 0 0 1-.81-1.302l-4.22-19.002M1367.53 320.295l-11.64 11.643M1354.15 320.947l6.37 6.365\" stroke=\"#000\"/>\r\n        <path d=\"M1367.53 320.294c-7.25-12.086 2.42-24.169 22.96-22.96 1.21 20.543-10.87 30.21-22.96 22.96z\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n    <defs>\r\n        <clipPath id=\"x2mtfx2e5b\">\r\n            <path fill=\"#fff\" transform=\"translate(-58 150)\" d=\"M0 0h296v296H0z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"ytl1sylm8c\">\r\n            <path fill=\"#fff\" transform=\"scale(-1 1) rotate(-8.828 1528.156 1468.82)\" d=\"M0 0h39.404v39.404H0z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"e749lz473d\">\r\n            <path fill=\"#fff\" transform=\"rotate(23.463 -8.523 636.254)\" d=\"M0 0h95.75v95.75H0z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"nzycpm7n7e\">\r\n            <path fill=\"#fff\" transform=\"translate(1092.81 133.555)\" d=\"M0 0h66.281v68.352H0z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"wrik5te5gf\">\r\n            <path fill=\"#fff\" transform=\"translate(1142.02 57)\" d=\"M0 0h151.741v151.741H0z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"e75rlvfdzg\">\r\n            <path fill=\"#fff\" transform=\"scale(-1 1) rotate(-29.817 -557.075 2531.3)\" d=\"M0 0h27.169v27.169H0z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"fou4tdqpsh\">\r\n            <path fill=\"#fff\" transform=\"translate(1322 288)\" d=\"M0 0h74v74H0z\"/>\r\n        </clipPath>\r\n        <radialGradient id=\"3lbly1s43a\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"matrix(0 1354 -6045.77 0 959.999 130.5)\">\r\n            <stop stop-color=\"#fff\" stop-opacity=\"0\"/>\r\n            <stop offset=\".199\" stop-color=\"#C5A0EF\"/>\r\n        </radialGradient>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/JobCareersBackground.f01d2e291a6bd5b300f19a0f2eedb3e9.svg"),
        {
          React: SvgJobCareersBackground,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      